import { useState, useEffect } from "react";

// Returns a multiplier applied to animation durations.
// On mobile (<= 640px) animations are slowed down; on desktop factor = 1.
export const useSlowFactor = (mobileFactor = 1.4) => {
  const [factor, setFactor] = useState(() =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 640px)").matches
      ? mobileFactor
      : 1
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 640px)");
    const update = () => setFactor(mq.matches ? mobileFactor : 1);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [mobileFactor]);

  return factor;
};
